// extracted by mini-css-extract-plugin
export default {"toggle":"navbar_toggle__TxrCM"};